import { Component, Input, OnInit } from '@angular/core';
import { InnovationAndProductivity } from 'src/app/interfaces/home.interface';

@Component({
  selector: 'app-innovation-productivity',
  templateUrl: './innovation-productivity.component.html',
  styleUrls: ['./innovation-productivity.component.scss'],
})
export class InnovationProductivityComponent implements OnInit {
  @Input() initiativeData!: InnovationAndProductivity;
  @Input() type: string = 'Inflight';
  constructor() {}

  ngOnInit(): void {
    // console.log(this.initiativeData)
  }
}
